export function setBugsnagUser( user /* { name: '', email: '', company: '' }*/ ) {
  return {
    type: 'SET_BUGSNAG_USER',
    payload: user
  };
}

export function clearBugsnagUser( ) {
  return {
    type: 'CLEAR_BUGSNAG_USER',
    payload: {}
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/bugsnag.js